import React, { useContext } from 'react';
import { connectPagination, connectStats } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import { PageSizeContext } from '../../../context/searchContext';
import { LabelSmall } from '@styled';

const SearchStats = ({ currentRefinement, nbHits, nbSortedHits }) => {
    const [pageSize] = useContext(PageSizeContext);
    const hitCount = nbSortedHits || nbHits;

    if (hitCount === 0) {
        return null;
    }

    const paginationLimit = Number(process.env.ALGOLIA_PAGINATION_LIMIT);
    const totalCount = hitCount > paginationLimit ? paginationLimit : hitCount;
    const totalCountText = totalCount.toLocaleString('en') + (hitCount > paginationLimit ? '+' : '');
    const rangeStart = (currentRefinement * pageSize.hitsPerPage - pageSize.hitsPerPage + 1).toLocaleString('en');
    let rangeEnd = currentRefinement * pageSize.hitsPerPage;

    if (rangeEnd > totalCount) {
        rangeEnd = totalCount;
    }

    rangeEnd = rangeEnd.toLocaleString('en');

    return (
        <LabelSmall className="text-secondary">{`Displaying ${rangeStart}-${rangeEnd} of ${totalCountText}`}</LabelSmall>
    );
};

SearchStats.propTypes = {
    currentRefinement: PropTypes.number.isRequired,
    nbHits: PropTypes.number.isRequired,
    nbSortedHits: PropTypes.number,
};

export default connectStats(connectPagination(SearchStats));
